import { Box, FormControl, FormLabel, Typography } from '@mui/joy';
import { Dispatch, Fragment, useRef, useState } from 'react';
import { FileUpload, FileUploadOptions } from 'primereact/fileupload';
import { Avatar } from 'primereact/avatar';
import { Galleria } from 'primereact/galleria';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Grid } from '@mui/material';
import { Dialog } from 'primereact/dialog';
import { DataView } from 'primereact/dataview';
import { downloadFile, getDocumentHistoryDetails, getRecordDocuments, removeDocument, removeMetaDocument, setDocumentHistoryDetails } from '../../service/documentsService';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { GenericTableColumTypes, GenericTableFilterTypes } from '../../enum/TableView';
import { GenericTableColumns } from '../../models/GenericTableViewModel';
import { consultantRemove, consultantUpdate } from '../../service/consultantService';
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from 'react-router-dom';
import { RouteComponentProps } from '../../models/RouteComponent';
import GenericTableView from '../../components/GenericTableView';



export default function DocumentsHistoryView(props: RouteComponentProps) {
  const navigate = useNavigate();
  const [selectedDocument, setSelectedDocument] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const docDetails = getDocumentHistoryDetails();

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    's3_path': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'expire_at': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'status': { value: null, matchMode: FilterMatchMode.CONTAINS }
  }

  const queryParams: any = {
    'record_id': docDetails.recordId,
    'document_id': docDetails.documentId
  }


  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedDocument(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    setSelectedDocument(row.value);
    // setVisible(true);
    download(row);
  }

  const goBack = (row: any) => {
    navigate(-1);
  }

  const contextItemSelected = (row: any) => {
    setSelectedDocument(row.value);
  }


  const download = async (row: any) => {
    props.setGlobalLoader(true);
    await downloadFile(selectedDocument.name, selectedDocument.s3_key);
    props.setGlobalLoader(false);
  }


  const contextItems = () => {
    let objArray = [
      { label: 'View', icon: 'pi pi-fw pi-eye', command: download },
    ];
    return objArray;
  }



  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Document Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'status',
      header: 'Status',
      type: GenericTableColumTypes.Status,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'expire_at',
      header: 'Expire On',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false,
    },
    {
      field: 'uploaded_on',
      header: 'Upload On',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false,
    },
    {
      field: 'deleted_at',
      header: 'Replaced On',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false,
    },
  ];


  return (
    <Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          {docDetails?.name} Document History
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} queryParams={queryParams} baseFilters={baseFilter} url="meta-history" columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <ConfirmDialog />

      <Toast ref={toast} />


    </Fragment>
  );
}